import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { createUser } from '../../api/auth'
import { ThemeSwitcher, ButtonRed, ButtonPink, ButtonGrey } from '../../components/common/Button'
import { Chip } from '../../components/profile'

export default function CPostIntermediate() {
    const [ tagsConfirmed, setTagsConfirmed ] = useState(false);
    const [loadingData, setLoadingData ] = useState(false);
    const history = useHistory();
    const [tags, setTags] = useState([]);
    const dispatch = useDispatch();
    const [userData, setUserdata] = useState({
        email: "",
        password: "",
        displayName: "",
        userType: 1,
        username: "",
        gender: -1,
        tags: []
    })

    const handleCreatorRegister = async () => {
        try {
            setLoadingData(true);
            const res = await createUser(userData.email, userData.password, userData.displayName, userData.gender, userData.userType, userData.username, userData.tags)
            console.log('response is after registration: ', res);
            dispatch({
                type: 'TOOGLE_LOGGEDIN'
            })
            dispatch({
                type: 'UPDATE_USER_DATA',
                payload: res,
            })
            dispatch({
                type: 'UPDATE_NAV', payload: {
                    notification: false,
                    home: true,
                    search: false,
                    post: false,
                    chat: false,
                    profile: false
                }
            })
            document.getElementById('desktopWrapper').style.display = 'flex';
            document.getElementById('mobileWrapper').style.display = 'flex';
            document.getElementById('desktopNav').style.display = 'flex';
            history.push('/home')
        } catch (e) {
            // error handling and other msgs here
            setLoadingData(false);
        }
    }

    useEffect(() => {
        const historyData = history.location.state;
        if (historyData) {
            setUserdata(historyData);
            // console.log(userData)
        }
    }, [])

    useEffect(() => {
        if(tags.length === 0){
            setTagsConfirmed(false);
        } else {
            setTagsConfirmed(true);
            setUserdata({ email: userData.email, password: userData.password, displayName: userData.displayName, userType: userData.userType, username: userData.username, gender: userData.gender, tags: tags })
        }
    }, [tags])

    const goBack = () => {
        history.push({
            pathname: '/creator-setup',
            state: { email: userData.email, password: userData.password, displayName: userData.displayName, userType: userData.userType, username: userData.username, gender: userData.gender, tags: userData.tags }
        })
    }

    return (
        <div className="lover-auth-intermediate">
            <ThemeSwitcher />
            <img className='lover-logo lover-logo-size' src={require('../../assets/icons/logo.svg')} />
            <h5 className="lover-auth-intermediate-header" >Select tags apply to you</h5>
            <p className="lover-auth-intermediate-desc">To identify what's type of content you'll create, we need to know your content type. This will help Lovrs to have relevant content on their feed.</p>

            <div className="lover-auth-intermediate">
                
                <div id="editProfileTagsRow" style={{justifyContent: 'center'}}>
                        <Chip text="Kinky" isActive={(tags.includes("Kinky"))} onclick={() => {
                            if (tags.includes("Kinky")) {

                                tags.splice(tags.indexOf("Kinky"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Kinky"])
                                } else {
                                    setTags([...tags, "Kinky"])
                                }
                            }
                        }} />

                        <Chip text="Fetish" isActive={(tags.includes("Fetish"))} onclick={() => {
                            if (tags.includes("Fetish")) {

                                tags.splice(tags.indexOf("Fetish"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Fetish"])
                                } else {
                                    setTags([...tags, "Fetish"])
                                }
                            }
                        }} />

                        <Chip text="Asian" isActive={(tags.includes("Asian"))} onclick={() => {
                            if (tags.includes("Asian")) {

                                tags.splice(tags.indexOf("Asian"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Asian"])
                                } else {
                                    setTags([...tags, "Asian"])
                                }
                            }
                        }} />

                        <Chip text="BDSM" isActive={(tags.includes("BDSM"))} onclick={() => {
                            if (tags.includes("BDSM")) {

                                tags.splice(tags.indexOf("BDSM"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "BDSM"])
                                } else {
                                    setTags([...tags, "BDSM"])
                                }
                            }
                        }} />

                        <Chip text="Cosplay" isActive={(tags.includes("Cosplay"))} onclick={() => {
                            if (tags.includes("Cosplay")) {

                                tags.splice(tags.indexOf("Cosplay"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Cosplay"])
                                } else {
                                    setTags([...tags, "Cosplay"])
                                }
                            }
                        }} />

                        <Chip text="Big Ass" isActive={(tags.includes("Big Ass"))} onclick={() => {
                            if (tags.includes("Big Ass")) {

                                tags.splice(tags.indexOf("Big Ass"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Big Ass"])
                                } else {
                                    setTags([...tags, "Big Ass"])
                                }
                            }
                        }} />

                        <Chip text="Big tits" isActive={(tags.includes("Big tits"))} onclick={() => {
                            if (tags.includes("Big tits")) {

                                tags.splice(tags.indexOf("Big tits"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Big tits"])
                                } else {
                                    setTags([...tags, "Big tits"])
                                }
                            }
                        }} />

                        <Chip text="Latina" isActive={(tags.includes("Latina"))} onclick={() => {
                            if (tags.includes("Latina")) {

                                tags.splice(tags.indexOf("Latina"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Latina"])
                                } else {
                                    setTags([...tags, "Latina"])
                                }
                            }
                        }} />

                        <Chip text="Teen" isActive={(tags.includes("Teen"))} onclick={() => {
                            if (tags.includes("Teen")) {

                                tags.splice(tags.indexOf("Teen"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Teen"])
                                } else {
                                    setTags([...tags, "Teen"])
                                }
                            }
                        }} />

                        <Chip text="Pornstar" isActive={(tags.includes("Pornstar"))} onclick={() => {
                            if (tags.includes("Pornstar")) {

                                tags.splice(tags.indexOf("Pornstar"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Pornstar"])
                                } else {
                                    setTags([...tags, "Pornstar"])
                                }
                            }
                        }} />



                        <Chip text="Ebony" isActive={(tags.includes("Ebony"))} onclick={() => {
                            if (tags.includes("Ebony")) {

                                tags.splice(tags.indexOf("Ebony"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Ebony"])
                                } else {
                                    setTags([...tags, "Ebony"])
                                }
                            }
                        }} />

                        <Chip text="Mature" isActive={(tags.includes("Mature"))} onclick={() => {
                            if (tags.includes("Mature")) {

                                tags.splice(tags.indexOf("Mature"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Mature"])
                                } else {
                                    setTags([...tags, "Mature"])
                                }
                            }
                        }} />

                        <Chip text="MILF" isActive={(tags.includes("MILF"))} onclick={() => {
                            if (tags.includes("MILF")) {

                                tags.splice(tags.indexOf("MILF"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "MILF"])
                                } else {
                                    setTags([...tags, "MILF"])
                                }
                            }
                        }} />


                        <Chip text="Amateur" isActive={(tags.includes("Amateur"))} onclick={() => {
                            if (tags.includes("Amateur")) {

                                tags.splice(tags.indexOf("Amateur"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Amateur"])
                                } else {
                                    setTags([...tags, "Amateur"])
                                }
                            }
                        }} />

                        <Chip text="Gay/Lesbian" isActive={(tags.includes("Gay/Lesbian"))} onclick={() => {
                            if (tags.includes("Gay/Lesbian")) {

                                tags.splice(tags.indexOf("Gay/Lesbian"), 1)
                                setTags([...tags])
                            } else {
                                if (tags.length > 5) {
                                    while (tags.length > 5) {
                                        tags.shift();
                                        setTags([...tags])
                                    }
                                    setTags([...tags, "Gay/Lesbian"])
                                } else {
                                    setTags([...tags, "Gay/Lesbian"])
                                }
                            }
                        }} />

                </div>

                <div className="lover-auth-intermediate-action" >
                    {tagsConfirmed ? <ButtonRed icon="tick.svg" handleOnClick={handleCreatorRegister} text={loadingData ? "Please Wait" : "CONFIRM"} /> : <ButtonGrey icon="tick.svg" text="CONFIRM"/>}
                    <ButtonPink text="BACK" handleOnClick={goBack} />
                </div>    

            </div>
        </div>
    )
}
